import React from 'react'
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'

const styles = theme => ({
    board: {
        //backgroundColor: theme.palette.primary.light,
        padding: '8px',
        marginBottom: theme.spacing.unit,
        borderRadius: '4px',     
        //backgroundColor: '#ECEFF1'
        backgroundColor: theme.palette.primary.light,
    },
    counterWrapper: {
        padding: theme.spacing.unit,
        //backgroundColor: theme.palette.primary.main,
        backgroundColor: '#536DFE',
        borderRadius: '4px',
        color: 'white'

        
    },
    counterLable: {
        fontSize: '0.7500em',
       // textTransform: 'uppercase',
        marginRight: theme.spacing.unit,
    },
    counter: {
        fontWeight: 'bold',
    }
})
const CounterBoard = (props) => {
    const {classes, data } = props

    if(data===null)return null
    const renderCounter = (
        data.map((counter, key) =>
            <Grid key={key} item md='auto' xs='auto' >
            <div className={classes.counterWrapper}>
                <span className={classes.counterLable}>{counter.lable}</span><span className={classes.counter}>{counter.value}</span>
            </div>
            </Grid>
        )
    )


    return (
        <Grid container alignContent='flex-end' alignItems='flex-end'>
            <Grid item md={12} xs={12}>
                <div className={classes.board} >
                <Grid container alignItems='flex-end' alignContent='flex-end' spacing={8}>
                    {renderCounter}
                </Grid>
                </div>
            </Grid>
        </Grid>

    )

}

export default withStyles(styles)(CounterBoard)


// WEBPACK FOOTER //
// ./src/Container/Content/CounterBoard/CounterBoard.js